import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import { BoldFieldLabel, InputWrapper } from './css';
import { useLocaleContext } from '../../context/LocaleContext';
import { localeEn } from '../../misc';

const FieldMoney = ({ data }) => {
  const locale = useLocaleContext();
  const {
    name,
    label,
    value = '0',
    required,
    readonly = true,
    disabled,
    horizontalFormat,
    labelColor,
    currency = 'CAD'
  } = data;

  const formattedValue = new Intl.NumberFormat(
    locale === localeEn ? 'en-CA' : 'fr-CA',
    {
      style: 'currency',
      currency,
      minimumFractionDigits: 2
    }
  ).format(parseFloat(value) || 0);

  return (
    <div style={{ width: '100px' }}>
      <InputWrapper isHorizontal={horizontalFormat}>
        <span
          className="frg-body-font-14px"
          style={{
            flex: 1,
            color: labelColor,
            textAlign: horizontalFormat ? 'right' : 'left'
          }}
        >
          <BoldFieldLabel>
            <Typography block heading="h4" variant={{ size: 'h4', bold: true }}>
              {label}
              {required && `*`}
            </Typography>
          </BoldFieldLabel>
        </span>
        <input
          id={name}
          name={name}
          type="text"
          value={formattedValue}
          readOnly={readonly}
          disabled={disabled}
          className="frg-input-field color-light"
          style={{
            width: '100%',
            backgroundColor: readonly ? '#f5f5f5' : 'white'
          }}
        />
      </InputWrapper>
    </div>
  );
};

FieldMoney.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    horizontalFormat: PropTypes.bool,
    labelColor: PropTypes.string,
    currency: PropTypes.string
  }).isRequired
};

export default FieldMoney;
